// Overlay rendering (hook cards, b-roll cards) — Satori (JSX→SVG, pure JS) +
// @resvg/resvg-wasm (SVG→PNG). Direct port of the desktop Satori path; only the
// resvg binding changes (native → wasm).

import satori from 'satori';
import { initWasm, Resvg } from '@resvg/resvg-wasm';

let _wasmReady = null;
async function ensureResvg() {
  if (!_wasmReady) {
    // Vite serves the wasm from the package; adjust URL if you self-host it.
    const wasmUrl = (await import('@resvg/resvg-wasm/index_bg.wasm?url')).default;
    _wasmReady = initWasm(fetch(wasmUrl));
  }
  return _wasmReady;
}

// fonts: [{ name, data: ArrayBuffer, weight, style }] — lazy-load like desktop.
export async function renderOverlayPNG({ element, width, height, fonts }) {
  const svg = await satori(element, { width, height, fonts });
  await ensureResvg();
  const png = new Resvg(svg).render().asPng();
  return new Blob([png], { type: 'image/png' });
}

// Build + render the hook card (a transparent full-frame PNG with the headline card
// positioned per styleSettings). Honors the common hook knobs from the desktop app.
export async function renderHookPNG({ text, W, H, style = {}, fonts }) {
  const label = style.hookUppercase === false ? text : String(text).toUpperCase();
  const fontName = (fonts && fonts[0] && fonts[0].name) || 'TheBold';
  const fontSize = style.hookFontSize ? Math.round(W * (style.hookFontSize / 1080) * 1.0) : Math.round(W * 0.072);
  const vpos = typeof style.hookVerticalPosition === 'number' ? style.hookVerticalPosition : 8; // % from top
  const align = style.hookAlignment || 'center';
  const textColor = style.hookTextColor || '#F5E6A8';
  const bgEnabled = style.hookBgEnabled !== false;
  const bg = style.hookBackground || 'rgba(10,10,12,0.80)';
  const border = style.hookOutlineEnabled !== false ? `${style.hookBorderWidth || 4}px solid ${style.hookStrokeColor || '#D4AF37'}` : 'none';

  const element = {
    type: 'div',
    props: {
      style: {
        display: 'flex', width: `${W}px`, height: `${H}px`,
        alignItems: 'flex-start',
        justifyContent: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center',
        paddingTop: `${Math.round(H * (vpos / 100))}px`,
        paddingLeft: `${Math.round(W * 0.05)}px`, paddingRight: `${Math.round(W * 0.05)}px`,
      },
      children: [{
        type: 'div',
        props: {
          style: {
            display: 'flex', maxWidth: `${Math.round(W * 0.9)}px`,
            padding: bgEnabled ? `${Math.round(fontSize * 0.5)}px ${Math.round(fontSize * 0.7)}px` : '0px',
            borderRadius: '24px',
            background: bgEnabled ? bg : 'transparent',
            border: bgEnabled ? border : 'none',
            color: textColor, fontFamily: fontName,
            fontSize: `${fontSize}px`, fontWeight: 700,
            textAlign: align, lineHeight: 1.15,
            textShadow: style.hookShadowEnabled !== false ? '0 4px 18px rgba(0,0,0,0.6)' : 'none',
          },
          children: label,
        },
      }],
    },
  };
  return renderOverlayPNG({ element, width: W, height: H, fonts });
}
